import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

interface Props {
    isMobile: boolean | undefined;
}

export const useStyles = makeStyles<Theme, Props>(theme => ({
    container: {},
    containerMobile: {
        marginTop: 0,
    },
    containerForCreator: {
        marginTop: 0,
    },
    video: {
        width: '100% !important',
        marginTop: theme.spacing(1),
        marginBottom: '-7px',
        backgroundColor: 'black',
        objectFit: 'contain',
        maxHeight: '425px',
        [theme.breakpoints.up('lg')]: {
            borderRadius: '10px !important',
        },
        [theme.breakpoints.down('lg')]: {
            borderRadius: 0,
            marginTop: 0,
        },
        [theme.breakpoints.up('xl')]: {
            maxHeight: '500px',
        },
    },
    eventImageContainer: {
        position: 'relative',
        margin: '0 auto',
    },
    eventImage: {
        width: '100%',
        objectFit: 'cover',
        maxHeight: '425px',
        [theme.breakpoints.up('lg')]: {
            borderRadius: '10px !important',
        },
        [theme.breakpoints.down('lg')]: {
            borderRadius: 0,
            marginTop: 0,
        },
        [theme.breakpoints.up('xl')]: {
            maxHeight: '500px',
        },
    },
    playButton: {
        position: 'absolute',
        height: 65,
        width: 65,
        left: 22,
        bottom: 22,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    mt0: {
        marginTop: 0,
    },
}));
